import crypto from 'crypto';

export const encrypt = (textToEncrypt) => {
    
    const key = process.env.REACT_APP_FRONT_BACK_KEY

    const iv = process.env.REACT_APP_IVECTOR

    const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
    console.log(Buffer.from(key).toString('hex'));
console.log(Buffer.from(iv).toString('hex'));
    let encrypted = cipher.update(textToEncrypt, 'utf8', 'hex');
    encrypted += cipher.final('hex');
    return encrypted
} 